import script from "./KeHoachChiPhiPrintModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./KeHoachChiPhiPrintModal.vue?vue&type=script&lang=ts&setup=true"

import "./KeHoachChiPhiPrintModal.vue?vue&type=style&index=0&id=5b8b8b88&lang=scss&scoped=true"

import exportComponent from "/var/www/prod/fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b8b8b88"]])

export default __exports__